module.exports = __webpack_public_path__ + "img/red_028.93a6db59.png";